import { Typography } from '@mui/material';
import { useTranslation } from 'react-i18next';

export function SecurityFooter() {
  const { t } = useTranslation('entity-portal');

  return (
    <Typography
      variant="helper"
      color="text.secondary"
      textAlign="center"
      sx={{ maxWidth: 360 }}
    >
      {t('login.loginSecurityFooter')}
    </Typography>
  );
}
